import { isUUID as isUuid } from 'class-validator';
import type { UUIDVersion } from 'class-validator';
import type { UUID } from 'short-uuid';

export const isUUID = (str: unknown, ver: UUIDVersion = 4): str is UUID => isUuid(str, ver);
